import React from 'react';
import ReactECharts from 'echarts-for-react';
import { useAtom } from 'jotai';
import { dashSummaryAtom } from '../atoms-types/dashSummary';
import { Box, useTheme } from '@mui/material';

const WindDirGauge: React.FC = () => {
  const [dashSummary] = useAtom(dashSummaryAtom);
  const { WindDir, WindDirStr } = dashSummary.environSum;
  const theme = useTheme();

  const option = {
    series: [
      {
        type: 'gauge',
        min: 0,
        max: 360,
        splitNumber: 12,
        radius: '65%',
        startAngle: 90,
        endAngle: 450,
        axisLine: {
          lineStyle: {
            color: [[1, theme.palette.text.primary]],
            width: 3
          }
        },
        splitLine: {
          distance: -18,
          length: 18,
          lineStyle: {
            color: theme.palette.text.primary
          }
        },
        axisTick: {
          distance: -10,
          length: 10,
          lineStyle: {
            color: theme.palette.text.primary
          }
        },
        axisLabel: {
          distance: -40,
          color: theme.palette.warning.main,
          fontSize: 15,
          formatter: function(value: number) {
            if (value === 0 || value === 360) return 'N';
            if (value === 90) return 'E';
            if (value === 180) return 'S';
            if (value === 270) return 'W';
            return value;
          }
        },
        anchor: {
          show: true,
          size: 20,
          itemStyle: {
            borderColor: '#666',
            borderWidth: 2,
            color: '#666'
          }
        },
        pointer: {
          show: true,
          length: '50%',
          width: 6,
          itemStyle: {
            color: theme.palette.error.main
          }
        },
        detail: {
          valueAnimation: true,
          formatter: '{value}°\n\n\n\n' + WindDirStr,
          color: theme.palette.text.secondary,
          fontSize: 20,
          offsetCenter: ['0%', '0%'],
          rich: {
            name: {
              fontSize: 16,
              lineHeight: 30,
              color: theme.palette.text.secondary
            }
          }
        },
        progress: {
          show: true,
          width: 0,
          itemStyle: {
            color: 'transparent'
          },
          label: {
            show: true,
            formatter: WindDirStr,
            fontSize: 16,
            color: theme.palette.text.secondary,
            offsetCenter: [0, '30%']
          }
        },
        data: [{
          value: WindDir || 0
        }]
      }
    ]
  };

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      minHeight: '200px',
      aspectRatio: '1/1'
    }}>
      <ReactECharts
        option={option}
        style={{ 
          width: '100%', 
          height: '100%',
          maxWidth: '250px',
          maxHeight: '250px'
        }}
      />
    </Box>
  );
};

export default WindDirGauge;
